import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { Box, ChoiceChips } from '@sparknz/spark-pattern-library';
import { LinkRegion, trackCustomLink } from '@sparknz/tracking';

import { useProductDetails } from 'journey/productDetails/provider';
import { ProductDetailsActionTypes } from 'journey/productDetails/reducer/productDetails.reducer';
import { getSelectedDevice } from 'journey/productDetails/utils/device.utils';
import { useQuery } from 'shared/hooks';
import { getStorageOptionsFromSelectedDevice } from './utils/storageOptions.utils';

const CapacityOptions = () => {
  const {
    dispatch,
    deviceOffers,
    selectedColor,
    selectedDevice,
    selectedStorage,
    storageOptions,
  } = useProductDetails();

  const { query, replaceQuery } = useQuery();

  const { selectedDeviceStorage, selectedDeviceStorageOptions } =
    getStorageOptionsFromSelectedDevice({ deviceOffers, selectedDevice });

  const availableStorageOptions =
    storageOptions || selectedDeviceStorageOptions;

  if (isEmpty(availableStorageOptions)) {
    return null;
  }

  const handleChange = (value: string) => {
    trackCustomLink(value);

    const newSelectedDevice = getSelectedDevice(
      deviceOffers,
      selectedColor || selectedDevice.colorHex,
      value,
    );

    dispatch({
      type: ProductDetailsActionTypes.SelectStorage,
      selectedStorage: value,
    });

    replaceQuery({ ...query, offerId: newSelectedDevice.id });
  };

  return (
    <Box mb="s5">
      <LinkRegion regionId="chooseCapacityTab">
        <ChoiceChips<string>
          options={availableStorageOptions}
          selectedValue={selectedStorage || selectedDeviceStorage}
          onChange={handleChange}
        />
      </LinkRegion>
    </Box>
  );
};

export default CapacityOptions;
